export const EVENT_TABS = {
  ACTUAL: { label: 'Актуальные', value: 'actual' },
  ARCHIVE: { label: 'Архив', value: 'archive' },
} as const;
